<template>
  <b-row
    class="tier d-flex"
    v-bind:class="{
      mintingSoon: tier.status === 'minting',
      pending: tier.status === 'pending'
    }"
  >
    <b-col cols="6" md="7" class="left p-0">
      <div class="tier-number">
        <img :src="tier.image" alt="tier 2 bg" class="h-100" />
      </div>
      <ul class="tier-details mb-0" v-if="tier.active">
        <li v-for="detail in tier.details" :key="detail">{{ detail }}</li>
      </ul>
    </b-col>
    <b-col
      cols="6"
      md="5"
      class="d-flex justify-content-center mintingSoon p-0"
      v-if="tier.status === 'minting'"
    >
      <div class="tier-status">
        <a href="https://ongaia.com/snkrhud" class="tier-link" target="_blank" />
        <img
          src="@/assets/rebrand/home/minting-soon-bg.png"
          alt="pending bg"
          class="btn-border img-fluid"
        />

        <p class="tier-status-text m-0">NOW MINTING</p>
      </div>
    </b-col>
    <b-col
      cols="6"
      md="5"
      class="d-flex justify-content-center mintingSoon p-0"
      v-if="tier.status === 'nowminting'"
    >
      <div class="tier-status">
        <a href="https://ongaia.com/snkrhud" class="tier-link" target="_blank" />
        <img
          src="@/assets/rebrand/home/minting-soon-bg.png"
          alt="pending bg"
          class="btn-border img-fluid"
        />

        <p class="tier-status-text m-0">NOW MINTING</p>
      </div>
    </b-col>
    <b-col cols="6" md="5" class="d-flex pending p-0" v-if="tier.status === 'pending'">
      <div class=" tier-status">
        <img
          src="@/assets/rebrand/home/tier-bg.png"
          alt="tier 2 bg"
          class="btn-border img-fluid"
          v-if="tier.status === 'pending'"
        />
        <p class="tier-status-text m-0">PENDING</p>
      </div>
    </b-col>
    <div class="divider" />
  </b-row>
</template>

<script>
export default {
  name: 'MilestoneTier',
  props: ['tier'],
  methods: {
    tierStatus() {},
  },
};
</script>
<style>
@media (max-width: 992px) {
  main.landing .milestone-v2 .tiers .tier .tier-status {
    font-size: max(3vw, 1.4rem) !important;
    margin: 2% auto 5%;
  }
}
</style>
